var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Layout',{attrs:{"fields":_vm.fields,"data":_vm.data,"title":("OFX: " + _vm.bank)},on:{"delete-file":_vm.deleteFile,"finish-update":function($event){return _vm.$emit('finish-update')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }